<template>
<div>
    <h2>{{ store.selectedOrganization.name }}</h2>
    <ul class="top-list">
        <li @click="toggleExpand(e)" class="list-item" v-for="e in organizationEvents" :key="e.eventId">
            <span v-if="!isExpanded(e)" class="collapser collapsed"></span>
            <span v-else class="collapser expanded"></span>
            {{ e.name }}
            <div v-if="isExpanded(e)">
                <kk-event-participant-top-list :event="e" />
            </div>
        </li>
    </ul>
</div>
</template>

<script lang="ts">
import { store, Event } from "store";
import axios from "axios";
import { defineComponent } from "vue";

/**
 * @deprecated Unused component
 * TODO: Remove this component
 */
export default defineComponent({
    async mounted() {
        this.organizationEvents = (await axios.get<Event[]>("events/all", {
            params: {
                organizationId: store.selectedOrganization.organizationId
            }
        })).data;
    },
    data() {
        const expandedEvents: Event[] = [];
        const organizationEvents: Event[] = [];

        return {
            store: store,
            organizationEvents,
            expandedEvents
        };
    },
    methods: {
        isExpanded(event: Event): boolean {
            return this.expandedEvents.indexOf(event) !== -1;
        },
        toggleExpand(event: Event) {
            if (this.isExpanded(event))
                this.collapse(event);
            else
                this.expand(event);
        },
        expand(event: Event) {
            this.expandedEvents.push(event);
        },
        collapse(event: Event) {
            let eventPos = this.expandedEvents.indexOf(event);
            this.expandedEvents.splice(eventPos, 1);
        }
    },
    props: {
        numTop: {
            type: Number
        }
    }
})
</script>